import { render, staticRenderFns } from "./communityq_content_type_field.vue?vue&type=template&id=4d454d5d&lang=pug"
import script from "./communityq_content_type_field.vue?vue&type=script&lang=js"
export * from "./communityq_content_type_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports